import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Skeleton from '@mui/material/Skeleton';
import { useParams } from 'react-router-dom';
import {
  Dialog, DialogActions, DialogContent, Typography, Card, CardContent,
  Select, MenuItem, InputLabel, FormControl, TextField,   // ✅ ADD HERE
  DialogContentText, DialogTitle, Button, Popover,
  Snackbar, Alert, Tooltip, IconButton, Box,
} from '@mui/material';

import TagModal from './TagModal';
import katex from 'katex';
import 'katex/dist/katex.min.css';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import StyleIcon from "@mui/icons-material/Style";
import { useNavigate } from "react-router-dom";
import sanitizeHtml from 'sanitize-html';
import { FaChevronDown, FaChevronUp } from "react-icons/fa"; // For the arrow icons
import { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import AddIcon from '@mui/icons-material/Add';
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from '@mui/material/styles';
import skip from "./assets/skip.png";
import forgot from "./assets/forgot.png";
import partially from "./assets/partially.png";
import efforts from "./assets/efforts.png";
import convenient from "./assets/convenient.png";

const ImageButton = styled(IconButton)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 4,
  transition: "transform 0.2s",
  "&:hover": {
    transform: "scale(1.1)",
  },
}));

const Image = styled("img")(() => ({
  width: "50px",
  height: "50px",
  filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))",
}));



// Import the Clipboard module from Quill
const Clipboard = Quill.import("modules/clipboard");

class CustomClipboard extends Clipboard {
  onPaste(e) {
    e.preventDefault();
    const clipboardData = e.clipboardData || window.clipboardData;
    const html = clipboardData.getData("text/html");

    if (html) {
      const sanitizedHtml = sanitizeHtml(html, {
        allowedTags: sanitizeHtml.defaults.allowedTags.concat([
          "b", "i", "em", "strong", "span", "br", "u", "sub", "sup", "a", "p", "img"
        ]),
        allowedAttributes: false, // Strip all attributes except essential ones
      });

      // Insert the HTML at the cursor position
      const range = this.quill.getSelection();
      if (range) {
        this.quill.clipboard.dangerouslyPasteHTML(range.index, sanitizedHtml);
      }
    } else {
      const text = clipboardData.getData("text/plain");
      // Insert plain text as HTML with line breaks
      const formattedText = `<p>${text.replace(/\n/g, "<br>")}</p>`;
      const range = this.quill.getSelection();
      if (range) {
        this.quill.clipboard.dangerouslyPasteHTML(range.index, formattedText);
      }
    }
  }
}



// Register the custom clipboard
Quill.register("modules/clipboard", CustomClipboard);

// Add this function right after your imports and before the component
const sanitizeForSave = (html = "") => {
  if (!html) return "";
  return sanitizeHtml(html, {
    allowedTags: [
      "p", "br", "strong", "b", "em", "i", "u", "s",
      "sub", "sup", "ol", "ul", "li", "blockquote",
      "code", "pre", "div", "span", "img", "a"
    ],
    allowedAttributes: {
      a: ["href", "target", "rel"],
      img: ["src", "alt"],
      span: ["style"],
      div: ["style"],
      p: ["style"],
    },
    allowedSchemes: ["http", "https", "data"],
    transformTags: {
      "h1": "p", "h2": "p", "h3": "p", "h4": "p", "h5": "p", "h6": "p",
    },
  });
};


const TrueFalse = () => {
  const [cards, setCards] = useState([]);
  const [folderType, setFolderType] = useState(null); // 'own', 'free', or 'paid'
  const [isAssignedFolder, setIsAssignedFolder] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [currentQuestion, setCurrentQuestion] = useState('');
  const [currentAnswer, setCurrentAnswer] = useState('');
  const [currentExplanation, setCurrentExplanation] = useState('');
  const [isExplanation, setIsExplanation] = useState(false);
  const { subfolder_id } = useParams();
  const [userGuideOpen, setUserGuideOpen] = useState(false);


  // Edit Modal States
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editCardIndex, setEditCardIndex] = useState(null);
  const [editQuestion, setEditQuestion] = useState('');
  const [editAnswer, setEditAnswer] = useState('');
  const [editExplanation, setEditExplanation] = useState('');

  // Delete Dialog States
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteCardIndex, setDeleteCardIndex] = useState(null);

  // Tag Modal States
  const [tagModalOpen, setTagModalOpen] = useState(false);
  const [tagCardIndex, setTagCardIndex] = useState(null);
  const [tagModalPosition, setTagModalPosition] = useState({ top: 0, left: 0 });
const [tagsInput, setTagsInput] = useState("");
const [tags, setTags] = useState([]);
const [editTags, setEditTags] = useState([]);  

  // Popover Editor States
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [popoverAnchorEl, setPopoverAnchorEl] = useState(null);
  const [popoverContent, setPopoverContent] = useState('');
  const [editingField, setEditingField] = useState(null); // 'question' or 'explanation'
  const [selectionRange, setSelectionRange] = useState(null);

  // Refs to ReactQuill editors
  const questionQuillRef = useRef(null);
  const explanationQuillRef = useRef(null);

  const [collapsedQuestion, setCollapsedQuestion] = useState(false);
  const [collapsedAnswer, setCollapsedAnswer] = useState(false);
  const [collapsedExplanation, setCollapsedExplanation] = useState(false);

  const toggleQuestion = () => setCollapsedQuestion(!collapsedQuestion);
  const toggleAnswer = () => setCollapsedAnswer(!collapsedAnswer);
  const toggleExplanation = () =>
    setCollapsedExplanation(!collapsedExplanation);
  const [duplicateDialogOpen, setDuplicateDialogOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");

  const [dropdownVisible, setDropdownVisible] = useState(false); // Controls dropdown visibility
  const [selectedOption, setSelectedOption] = useState(''); // State to track selected option
  const navigate = useNavigate();
  const { mode, customColors } = useContext(ThemeContext);

  // state for viewing flashcard details
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewedCard, setViewedCard] = useState(null);
  const [showAnswer, setShowAnswer] = useState(false);    
  const [selectedFeeling, setSelectedFeeling] = useState(null); 

  // Add to state declarations
  const [permissions, setPermissions] = useState({
    can_create_tf: true,
    can_read_tf: true,
    can_update_tf: true,
    can_delete_tf: true,
    can_start_flashcard: true,
    can_start_quiz: true,
    is_admin: false,
  });
  const [isLoadingPermissions, setIsLoadingPermissions] = useState(false);
  const apiUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
  const initializeComponent = async () => {
    setIsLoading(true);
    
    try {
      // Step 1: Check folder type
      const token = sessionStorage.getItem("authToken");
      const folderResponse = await axios.get(`${apiUrl}/folders/`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      const isOwn = folderResponse.data.own_folders.some(folder => 
        folder.id === parseInt(subfolder_id) || 
        folder.subfolders?.some(sf => sf.id === parseInt(subfolder_id))
      );
      
      if (isOwn) {
        setFolderType('own');
        setIsAssignedFolder(false);
      } else {
        const isFree = folderResponse.data.assigned_folders.free.some(folder => 
          folder.id === parseInt(subfolder_id) || 
          folder.subfolders?.some(sf => sf.id === parseInt(subfolder_id))
        );
        
        if (isFree) {
          setFolderType('free');
          setIsAssignedFolder(true);
        } else {
          setFolderType('paid');
          setIsAssignedFolder(true);
        }
      }

      // Step 2: Fetch permissions
      const userRole = sessionStorage.getItem("userRole");
      let permissionsData;
      
      if (userRole === "admin") {
        permissionsData = {
          can_create_tf: true,
          can_read_tf: true,
          can_update_tf: true,
          can_delete_tf: true,
          can_start_flashcard: true,
          can_start_quiz: true,
          is_admin: true,
        };
        setPermissions(permissionsData);
      } else {
        const permResponse = await axios.get(`${apiUrl}/user/permissions/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        
        const {
          can_create_tf,
          can_read_tf,
          can_update_tf,
          can_delete_tf,
          can_start_flashcard,
          can_start_quiz,
        } = permResponse.data.permissions || {};
        
        permissionsData = {
          can_create_tf: can_create_tf || false,
          can_read_tf: can_read_tf || false,
          can_update_tf: can_update_tf || false,
          can_delete_tf: can_delete_tf || false,
          can_start_flashcard: can_start_flashcard || false,
          can_start_quiz: can_start_quiz || false,
          is_admin: false,
        };
        setPermissions(permissionsData);
      }

      // Step 3: Fetch flashcards if user has permission
      if (permissionsData.can_read_tf || permissionsData.is_admin) {
        const response = await axios.get(
          `${apiUrl}/subfolder/${subfolder_id}/truefalse/`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const fetchedCards = response.data.map(item => ({
          id: item.id,
          question: item.statement,
          question_type: item.question_type,
          answer: item.answers,
          explanation: item.explanation,
          expanded: false,
          tags: item.tags,
        }));
        setCards(fetchedCards);
      }
      
    } catch (error) {
      console.error("Failed to initialize component:", error);
      showSnackbar("Failed to load data. Please try again.", "error");
    } finally {
      setIsLoading(false);
    }
  };

  initializeComponent();
}, [subfolder_id, apiUrl]);


  // Function to handle snackbar close
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  // Function to show snackbar with message and severity
  const showSnackbar = (message, severity = "error") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const fetchFlashcardsFromServer = async () => {
    if (!permissions.can_read_tf && !permissions.is_admin) {
      showSnackbar("You don't have permission to view True/False Questions.", "warning");
      return;
    }
    try {
      const token = sessionStorage.getItem("authToken");
      if (!token) {
        console.error('Access token is missing. Please log in again.');
        showSnackbar("You are not authenticated. Please login again.", "error");
        return;
      }
      const response = await axios.get(`${apiUrl}/subfolder/${subfolder_id}/truefalse/`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      const fetchedCards = response.data.map(item => ({
        id: item.id,
        question: item.statement,
        question_type: item.question_type,
        answer: item.answers,
        explanation: item.explanation,
        expanded: false,
        tags: item.tags,
      }));
      setCards(fetchedCards);
    } catch (error) {
      console.error('Failed to fetch flashcards from server', error);
      showSnackbar("Failed to fetch flashcards. Please try again.", "error");
    }
  };


  const renderContent = (html) => {
    if (!html) return null;

    // Split content into LaTeX and non-LaTeX parts
    const parts = html.split(/(\$\$.+?\$\$|\$.+?\$)/g);

    return (
      <div>
        {parts.map((part, index) => {
          // Handle block-level LaTeX ($$...$$)
          if (part.startsWith("$$") && part.endsWith("$$")) {
            const latex = part.slice(2, -2); // Remove $$ delimiters
            try {
              const renderedLatex = katex.renderToString(latex, { displayMode: true });
              return (
                <div
                  key={index}
                  dangerouslySetInnerHTML={{ __html: renderedLatex }}
                  className="rendered-content block-latex"
                />
              );
            } catch (error) {
              console.error("Block LaTeX rendering error:", error);
              return <div key={index} className="error-content">{part}</div>;
            }
          }

          // Handle inline LaTeX ($...$)
          if (part.startsWith("$") && part.endsWith("$")) {
            const latex = part.slice(1, -1); // Remove $ delimiters
            try {
              const renderedLatex = katex.renderToString(latex, { displayMode: false });
              return (
                <span
                  key={index}
                  dangerouslySetInnerHTML={{ __html: renderedLatex }}
                  className="rendered-content inline-latex"
                />
              );
            } catch (error) {
              console.error("Inline LaTeX rendering error:", error);
              return <span key={index} className="error-content">{part}</span>;
            }
          }

          // Handle non-LaTeX content
          try {
            const formattedContent = part.replace(/\n/g, "<br />"); // Replace newlines
            const allowedTags = ["b", "i", "em", "strong", "span", "br", "u", "sub", "sup", "a", "p", "img"];
            const allowedAttributes = {
              img: ["src", "alt"],
              a: ["href", "target"],
              span: ["style"],
              p: ["style"],
            };

            // Use sanitize-html or DOMPurify with selective sanitization
            const sanitizedContent = sanitizeHtml(formattedContent, {
              allowedTags,
              allowedAttributes,
              transformTags: {
                'p': 'span', // Convert <p> tags to <span>
                'div': 'span', // Convert <div> tags to <span>
              },
            });

            return (
              <span
                key={index}
                dangerouslySetInnerHTML={{ __html: sanitizedContent }}
                className="rendered-content inline-text"
              />
            );
          } catch (error) {
            console.error("HTML rendering error:", error);
            return <span key={index} className="error-content">{part}</span>;
          }
        })}
      </div>
    );
  };



  const handleApiCall = async () => {
    if (!permissions.can_create_tf && !permissions.is_admin) {
      showSnackbar(
        "You don't have permission to create True/False Questions.",
        "warning"
      );
      return;
    }

   if (!currentQuestion.trim() || !currentAnswer) {
  showSnackbar(
    "Please fill in the question and answer fields before submitting.",
    "warning"
  );
  return;
}

// ✅ ADD THIS BLOCK
if (tags.length === 0) {
  showSnackbar(
    "Please add at least one tag before adding the flashcard.",
    "warning"
  );
  return;
}

    // 1. Safely sanitize HTML but keep formatting (bold, sup, sub, $, etc.)
    const questionHtml = sanitizeForSave(currentQuestion);
    const explanationHtml = sanitizeForSave(currentExplanation);

    // 2. For duplicate check: compare only plain text (smart way)
    const questionTextOnly = questionHtml
      .replace(/<[^>]*>/g, "") // Remove all HTML tags
      .replace(/\s+/g, " ") // Collapse multiple spaces/newlines
      .trim();

    const isDuplicate = cards.some((card) => {
      const existingText = sanitizeForSave(card.question || "")
        .replace(/<[^>]*>/g, "")
        .replace(/\s+/g, " ")
        .trim();
      return existingText === questionTextOnly;
    });

    if (isDuplicate) {
      setDuplicateDialogOpen(true);
      return;
    }

    // 3. Payload with rich HTML preserved
    const payload = {
      statement: questionHtml,
      created_by: "Admin",
      question_type: "TRUEFALSE",
      answers: currentAnswer === "True",
      explanation: explanationHtml || "",
       tags: tags, // <-- Add this line
    };

    try {
      const token = sessionStorage.getItem("authToken");
      if (!token) {
        showSnackbar("You are not authenticated. Please login again.", "error");
        return;
      }

      const response = await fetch(
        `${apiUrl}/subfolder/${subfolder_id}/truefalse/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      // Success: Refresh cards and reset form
      fetchFlashcardsFromServer();
      setCurrentQuestion("");
      setCurrentAnswer("");
      setCurrentExplanation("");
      setIsExplanation(false);
      setTags([]);
setTagsInput("");
      showSnackbar("Flashcard added successfully!", "success");
    } catch (error) {
      console.error("Error:", error);
      showSnackbar("Failed to save flashcard, please try again.", "error");
    }
  };


  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !isExplanation) {
      setIsExplanation(true);
    } else if (e.key === 'Enter' && isExplanation) {
      handleApiCall();
    }
  };

  const toggleCardExpand = (index) => {
    const newCards = [...cards];
    newCards[index].expanded = !newCards[index].expanded;
    setCards(newCards);
  };

  // Edit Modal Functions
  const openEditModal = (index) => {
    if (!permissions.can_update_tf && !permissions.is_admin) {
      showSnackbar("You don't have permission to update True/False Questions.", "warning");
      return;
    }
    setEditCardIndex(index);
    setEditQuestion(cards[index].question);
    setEditAnswer(
      cards[index].answer === true || cards[index].answer === "True"
        ? "True"
        : "False"
    );

    setEditExplanation(cards[index].explanation);
    setEditModalOpen(true);
  };

  const openViewModal = (card) => {
  setViewedCard(card);
  setShowAnswer(false);
  setViewModalOpen(true);
};

  const handleEditChange = (setter) => (value) => {
    setter(value);
  };

  const handleConfirmDuplicate = async () => {
    if (!permissions.can_create_tf && !permissions.is_admin) {
      showSnackbar("You don't have permission to create True/False Questions.", "warning");
      setDuplicateDialogOpen(false);
      return;
    }
    const cleanQuestion = sanitizeForSave(currentQuestion);
    const cleanExplanation = sanitizeForSave(currentExplanation);
    const payload = {
      statement: cleanQuestion,
      created_by: "Admin",
      question_type: "TRUEFALSE",
      answers: currentAnswer === "True",
      explanation: cleanExplanation,
      tags: [],
    };
    try {
      const token = sessionStorage.getItem("authToken");
      if (!token) {
        showSnackbar("You are not authenticated. Please login again.", "error");
        return;
      }
      const response = await fetch(`${apiUrl}/subfolder/${subfolder_id}/truefalse/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      fetchFlashcardsFromServer();
      setCurrentQuestion("");
      setCurrentAnswer("");
      setCurrentExplanation("");
      setIsExplanation(false);
      setDuplicateDialogOpen(false);
      showSnackbar("Flashcard added successfully!", "success");
    } catch (error) {
      console.error("Error:", error);
      showSnackbar("Failed to save flashcard, please try again.", "error");
    }
  };

  const handleCancelDuplicate = () => {
    setDuplicateDialogOpen(false);
  };

  const handleUpdateCard = async () => {
    if (!permissions.can_update_tf && !permissions.is_admin) {
      showSnackbar("You don't have permission to update True/False Questions.", "warning");
      return;
    }
    const cleanQuestion = sanitizeForSave(editQuestion);
    const cleanExplanation = sanitizeForSave(editExplanation);
    const updatedCard = {
      statement: cleanQuestion,
      created_by: "Admin",
      question_type: "TRUEFALSE",
      answers: editAnswer === "True",
      explanation: cleanExplanation,
      tags: editTags, // <-- Add this line
    };
    try {
      const token = sessionStorage.getItem("authToken");
      if (!token) {
        showSnackbar("You are not authenticated. Please login again.", "error");
        return;
      }
      const cardId = cards[editCardIndex].id;
      await axios.put(`${apiUrl}/subfolder/${subfolder_id}/truefalse/${cardId}/`,
        updatedCard,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const updatedCards = [...cards];
      updatedCards[editCardIndex] = {
        ...updatedCards[editCardIndex],
        question: editQuestion,
        answer: editAnswer === "True",
        explanation: editExplanation,
      };
      setCards(updatedCards);
      setEditModalOpen(false);
      showSnackbar("Flashcard updated successfully!", "success");
    } catch (error) {
      console.error("Failed to update flashcard on server", error);
      showSnackbar("Failed to update flashcard, please try again.", "error");
    }
  };


  const handleCloseModal = () => {
    setEditModalOpen(false);
  };

  // Delete Dialog Functions
  const openDeleteDialog = (index) => {
    if (!permissions.can_delete_tf && !permissions.is_admin) {
      showSnackbar("You don't have permission to delete True/False Questions.", "warning");
      return;
    }
    setDeleteCardIndex(index);
    setDeleteDialogOpen(true);
  };

  // Delete Card Handler
  const handleDeleteCard = async () => {
    if (!permissions.can_delete_tf && !permissions.is_admin) {
      showSnackbar("You don't have permission to delete True/False Questions.", "warning");
      return;
    }
    try {
      const token = sessionStorage.getItem("authToken");
      if (!token) {
        showSnackbar("You are not authenticated. Please login again.", "error");
        return;
      }
      const cardId = cards[deleteCardIndex].id;
      await axios.delete(`${apiUrl}/subfolder/${subfolder_id}/truefalse/${cardId}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const updatedCards = cards.filter(
        (_, index) => index !== deleteCardIndex
      );
      setCards(updatedCards);
      setDeleteDialogOpen(false);
      showSnackbar("Flashcard deleted successfully!", "success");
    } catch (error) {
      console.error("Failed to delete flashcard from server", error);
      showSnackbar("Failed to delete flashcard, please try again.", "error");
    }
  };


  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
  };

  // Tag Modal Functions
  const openTagModal = (index, event) => {
    const iconRect = event.target.getBoundingClientRect();
    setTagCardIndex(index);
    setTagModalPosition({
      top: iconRect.bottom + window.scrollY,
      left: iconRect.left + window.scrollX,
    });
    setTagModalOpen(true);
  };

  const handleTagAdded = (cardId, newTag) => {
    if (!cardId || !newTag || !newTag.name) {
      console.error('Invalid tag data:', { cardId, newTag });
      showSnackbar('Invalid tag data. Please try again.', 'error');
      return;
    }

    try {
      const updatedCards = cards.map((card) => {
        if (card.id === cardId) {
          return {
            ...card,
            tags: [...card.tags, { name: newTag.name, id: newTag.id || null }],
          };
        }
        return card;
      });
      setCards(updatedCards);
      setTagModalOpen(false); // Close modal
    } catch (error) {
      console.error('Error updating local state in handleTagAdded:', error);
      showSnackbar('Failed to update tag locally: ' + error.message, 'error');
    }
  };

  const handleTagUpdated = (cardId, updatedTag) => {
    if (!cardId || !updatedTag || !updatedTag.id || !updatedTag.name) {
      console.error('Invalid tag update data:', { cardId, updatedTag });
      showSnackbar('Invalid tag update data. Please try again.', 'error');
      return;
    }

    try {
      const updatedCards = cards.map((card) => {
        if (card.id === cardId) {
          return {
            ...card,
            tags: card.tags.map((tag) =>
              tag.id === updatedTag.id ? { ...tag, name: updatedTag.name } : tag
            ),
          };
        }
        return card;
      });
      setCards(updatedCards);
    } catch (error) {
      console.error('Error updating local state in handleTagUpdated:', error);
      showSnackbar('Failed to update tag locally: ' + error.message, 'error');
    }
  };

  const handleTagDeleted = (cardId, tagId) => {
    if (!cardId || !tagId) {
      console.error('Invalid tag deletion data:', { cardId, tagId });
      showSnackbar('Invalid tag deletion data. Please try again.', 'error');
      return;
    }

    try {
      const updatedCards = cards.map((card) => {
        if (card.id === cardId) {
          return {
            ...card,
            tags: card.tags.filter((tag) => tag.id !== tagId),
          };
        }
        return card;
      });
      setCards(updatedCards);
    } catch (error) {
      console.error('Error updating local state in handleTagDeleted:', error);
      showSnackbar('Failed to delete tag locally: ' + error.message, 'error');
    }
  };

  // Popover Editor Functions
  const handleContextMenu = (event, field) => {
    event.preventDefault();
    const quillRef = field === 'question' ? questionQuillRef.current : explanationQuillRef.current;
    if (quillRef) {
      const quill = quillRef.getEditor();
      const selection = quill.getSelection();
      if (selection && selection.length > 0) {
        const selectedText = quill.getText(selection.index, selection.length);
        setPopoverContent(selectedText);
        setEditingField(field);
        setPopoverAnchorEl(event.currentTarget);
        setPopoverOpen(true);
        setSelectionRange(selection);
      }
    }
  };

  const handlePopoverClose = () => {
    setPopoverOpen(false);
    setPopoverAnchorEl(null);
    setPopoverContent('');
    setEditingField(null);
    setSelectionRange(null);
  };

  const handlePopoverSave = () => {
    if (selectionRange && editingField) {
      const quillRef = editingField === 'question' ? questionQuillRef.current : explanationQuillRef.current;
      if (quillRef) {
        const quill = quillRef.getEditor();
        quill.deleteText(selectionRange.index, selectionRange.length);
        quill.insertText(selectionRange.index, popoverContent);
        // Update the corresponding state
        if (editingField === 'question') {
          setCurrentQuestion(quill.root.innerHTML);
        } else {
          setCurrentExplanation(quill.root.innerHTML);
        }
      }
    }
    handlePopoverClose();
  };

  const handlePopoverChange = (value) => {
    setPopoverContent(value);
  };
  const handleIconClick = () => {
    // Toggle dropdown visibility when icon is clicked
    setDropdownVisible(!dropdownVisible);
  };
  const handleDropdownChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedOption(selectedValue);

    const hardCodedText = "truefalse";

    if (selectedValue === "practiceCard" && !permissions.can_start_flashcard && !permissions.is_admin) {
      showSnackbar("You don't have permission to start Practice Flashcard.", "warning");
      return;
    }
    if (selectedValue === "quizPractice" && !permissions.can_start_quiz && !permissions.is_admin) {
      showSnackbar("You don't have permission to start Quiz Practice.", "warning");
      return;
    }

    if (selectedValue === "practiceCard") {
      navigate(
        `/practiceparticularcard/${subfolder_id}/${encodeURIComponent(hardCodedText)}`
      );
    } else if (selectedValue === "spacedrep") {
      navigate(
        `/practicespacedrep/${subfolder_id}/${encodeURIComponent(hardCodedText)}`
      );
    } else if (selectedValue === "quizPractice") {
      navigate(
        `/quizpractice/${subfolder_id}/${encodeURIComponent(hardCodedText)}`
      );
    }

    setDropdownVisible(false);
  };
const isFormValid =
  currentQuestion.trim() !== "" &&
  currentAnswer !== "" &&
  tags.length > 0;
return (
  <div style={{ position: "relative", marginBottom: "12px" }}>
   


        {isLoading ? (
  <Box sx={{ p: 2 }}>
    {[...Array(4)].map((_, i) => (
      <Box
        key={i}
        sx={{
          mb: 2,
          p: 2,
          borderRadius: "16px",
          border: mode === "dark" ? "1px solid #333" : "1px solid #e0e7ff",
          backgroundColor: mode === "dark" ? "#2A2A3E" : "#fff",
        }}
      >
        {/* Question row */}
        <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
          <Skeleton
            variant="rectangular"
            width={45}
            height={40}
            sx={{ borderRadius: "10px", mr: 2 }}
          />
          <Skeleton variant="text" width="70%" height={28} />
        </Box>
        {/* Tag chips */}
        <Box sx={{ display: "flex", gap: 1 }}>
          <Skeleton variant="rounded" width={60} height={22} />
          <Skeleton variant="rounded" width={80} height={22} />
          <Skeleton variant="rounded" width={50} height={22} />
        </Box>
      </Box>
    ))}
  </Box>
     


    ) : (
      <>
        {!isAssignedFolder ? (
          // Full edit mode UI (same as your current UI)
          <div style={{ position: 'relative', marginBottom: '12px' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          gap: '8px',
        }}
      >
        <Typography
          variant="h4"
          sx={{
            mb: 3,
            fontWeight: '800',
            background: mode === "dark"
              ? "linear-gradient(135deg, #f0f7ff 0%, #e0e7ff 100%)"
              : mode === "custom"
                ? "#f5f5f5" || "#222222"
                : "linear-gradient(135deg, #1e3a8a 0%, #1e8bafff 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: 'text'
          }}
        >
          True/False Questions
        </Typography>

        


        <div style={{ position: "relative" }}>
          {/* <StyleIcon
            onClick={() => setDropdownVisible(!dropdownVisible)}
            sx={{ cursor: "pointer", color: "primary.dark", '&:focus': { outline: 'none' } }}
          /> */}
          <Tooltip title="User Guide">
          <IconButton
            onClick={() => setUserGuideOpen(true)}
            sx={{
              color: mode === "dark" ? "#90caf9" : "#1e8bafff",
              backgroundColor: mode === "dark"
                ? "rgba(144, 202, 249, 0.1)"
                : "rgba(30, 139, 175, 0.1)",
              "&:hover": {
                backgroundColor: mode === "dark"
                  ? "rgba(144, 202, 249, 0.2)"
                  : "rgba(30, 139, 175, 0.2)",
              },
              '&:focus': { outline: 'none' }
            }}
          >
            <InfoIcon />
          </IconButton>
        </Tooltip>
          {dropdownVisible && (
            <div
              style={{
                position: "absolute",
                top: "30px",
                right: "-30px",
                zIndex: 1,
                backgroundColor:
                  mode === "dark"
                    ? "#1E1E2E"
                    : mode === "custom"
                      ? customColors.background
                      : "#e3f2fd", // light mode
                color:
                  mode === "dark"
                    ? "#E0E0E6"
                    : mode === "custom"
                      ? customColors.text
                      : "#000000", // light mode
                border: "1px solid #ccc",
                borderRadius: "4px",
                padding: "0",
              }}
            >
              {/* <div
                onClick={() =>
                  handleDropdownChange({ target: { value: "practiceCard" } })
                }
                style={{
                  cursor: permissions.can_start_flashcard || permissions.is_admin ? "pointer" : "not-allowed",
                  padding: "10px 15px",
                  transition: "background-color 0.3s ease",
                  whiteSpace: "nowrap",
                  opacity: permissions.can_start_flashcard || permissions.is_admin ? 1 : 0.5,
                }}
                onMouseEnter={(e) => {
                  if (permissions.can_start_flashcard || permissions.is_admin) {
                    e.currentTarget.style.backgroundColor =
                      mode === "dark"
                        ? "#50565cff"
                        : mode === "custom"
                          ? customColors.background
                          : "#ffffff"; // light mode default
                  }
                }}
                onMouseLeave={(e) =>
                  (permissions.can_start_flashcard || permissions.is_admin) && (e.currentTarget.style.backgroundColor = "transparent")
                }
              >
                Practice FlashCard
              </div> */}
              {/* <div
                onClick={() =>
                  handleDropdownChange({ target: { value: "spacedrep" } })
                }
                style={{
                  cursor: "pointer",
                  padding: "10px 15px",
                  transition: "background-color 0.3s ease",
                  whiteSpace: "nowrap",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = darkMode ? "#50565cff" : "#bbdefb")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "transparent")
                }
              >
                Practice with Spaced Repetition
              </div> */}
              {/* <div
                onClick={() =>
                  handleDropdownChange({ target: { value: "quizPractice" } })
                }
                style={{
                  cursor: permissions.can_start_quiz || permissions.is_admin ? "pointer" : "not-allowed",
                  padding: "10px 15px",
                  transition: "background-color 0.3s ease",
                  whiteSpace: "nowrap",
                  opacity: permissions.can_start_quiz || permissions.is_admin ? 1 : 0.5,
                }}
                onMouseEnter={(e) => {
                  if (permissions.can_start_quiz || permissions.is_admin) {
                    e.currentTarget.style.backgroundColor =
                      mode === "dark"
                        ? "#50565cff"
                        : mode === "custom"
                          ? customColors.background
                          : "#ffffff"; // light mode default
                  }
                }}
                onMouseLeave={(e) =>
                  (permissions.can_start_quiz || permissions.is_admin) && (e.currentTarget.style.backgroundColor = "transparent")
                }
              >
                Quiz Practice
              </div> */}
            </div>
          )}
        </div>
      </div>
      {/* Question Field with Arrow */}
      <Card
        sx={{
          mb: 2,
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
          backgroundColor: mode === "dark" ? "#1E1E2E" : "#fff",
          border: "1px solid",
          borderColor: mode === "dark" ? "#333" : "#e0e7ff",
        }}
      >
        <CardContent>
          <div style={{ marginBottom: "10px" }}>
            <div
              style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
              onClick={toggleQuestion}
            >
              <div style={{ marginRight: "10px" }}>
                {collapsedQuestion ? <FaChevronDown /> : <FaChevronUp />}
              </div>
              <div>Question <span style={{ color: 'red' }}>*</span> </div>
            </div>
            {/* Initially shown and collapsible */}
            <div style={{ display: collapsedQuestion ? "none" : "block" }}>
              <ReactQuill
                value={currentQuestion}
                onChange={setCurrentQuestion}
                placeholder="Enter your question"
                modules={{
                  toolbar: [
                    ["bold", "italic", "underline", "strike"],
                    ["blockquote", "code-block"],
                    [{ header: 1 }, { header: 2 }],
                    [{ list: "ordered" }, { list: "bullet" }],
                    [{ script: "sub" }, { script: "super" }],
                    [{ indent: "-1" }, { indent: "+1" }],
                    [{ direction: "rtl" }],
                    [{ size: ["small", false, "large", "huge"] }],
                    [{ header: [1, 2, 3, 4, 5, 6, false] }],
                    [{ color: [] }, { background: [] }],
                    [{ font: [] }],
                    [{ align: [] }],
                    ["clean"],
                  ],
                }}
                formats={[
                  "header",
                  "font",
                  "size",
                  "bold",
                  "italic",
                  "underline",
                  "strike",
                  "blockquote",
                  "code-block",
                  "list",
                  "bullet",
                  "indent",
                  "link",
                  "image",
                  "video",
                  "color",
                  "background",
                  "align",
                  "script",
                  { name: "preserve-spaces", type: "inline" },
                ]}
                style={{
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  whiteSpace: "pre-wrap",
                }}
              />
            </div>
          </div> </CardContent></Card>

      {/* Answer Field with Arrow */}
      <Card
        sx={{
          mb: 2,
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
          backgroundColor: mode === "dark" ? "#1E1E2E" : "#fff",
          border: "1px solid",
          borderColor: mode === "dark" ? "#333" : "#e0e7ff",
        }}
      >
        <CardContent>
          <div style={{ marginBottom: "10px" }}>
            <div
              style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
              onClick={toggleAnswer}
            >
              <div style={{ marginRight: "10px" }}>
                {collapsedAnswer ? <FaChevronDown /> : <FaChevronUp />}
              </div>
              <div>Answer <span style={{ color: 'red' }}>*</span> </div>
            </div>
            {/* Initially shown and collapsible */}
            <div style={{ display: collapsedAnswer ? "none" : "block" }}>
              <Select
                className={`form-control ${mode}-mode mt-1 p-2 w-full border border-gray-300 rounded-md`}
                value={currentAnswer}
                onChange={(e) => setCurrentAnswer(e.target.value)}
                displayEmpty
                style={{
                  wordBreak: "break-all",
                  overflowWrap: "anywhere",
                }}
              >
                <MenuItem value="">
                  <em>Select</em>
                </MenuItem>

                <MenuItem
                  value="True"
                  sx={{
                    backgroundColor:
                      mode === "dark"
                        ? "transparent"
                        : mode === "custom"
                          ? customColors.background
                          : "transparent",
                    color:
                      mode === "dark"
                        ? "white"
                        : mode === "custom"
                          ? customColors.text
                          : "gray",
                  }}
                >
                  True
                </MenuItem>

                <MenuItem
                  value="False"
                  sx={{
                    backgroundColor:
                      mode === "dark"
                        ? "transparent"
                        : mode === "custom"
                          ? customColors.background
                          : "transparent",
                    color:
                      mode === "dark"
                        ? "white"
                        : mode === "custom"
                          ? customColors.text
                          : "gray",
                  }}
                >
                  False
                </MenuItem>
              </Select>
            </div>

          </div> </CardContent></Card>

      {/* Explanation Field with Arrow */}
      <Card
        sx={{
          mb: 2,
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
          backgroundColor: mode === "dark" ? "#1E1E2E" : "#fff",
          border: "1px solid",
          borderColor: mode === "dark" ? "#333" : "#e0e7ff",
        }}
      >
        <CardContent>
          <div style={{ marginBottom: "10px" }}>
            <div
              style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
              onClick={toggleExplanation}
            >
              <div style={{ marginRight: "10px" }}>
                {collapsedExplanation ? <FaChevronDown /> : <FaChevronUp />}
              </div>
              <div>Explanation</div>
            </div>
            {/* Initially shown and collapsible */}
            <div style={{ display: collapsedExplanation ? "none" : "block" }}>
              <ReactQuill
                value={currentExplanation}
                onChange={setCurrentExplanation}
                placeholder="Enter your explanation"
                modules={{
                  toolbar: [
                    ["bold", "italic", "underline", "strike"],
                    ["blockquote", "code-block"],
                    [{ header: 1 }, { header: 2 }],
                    [{ list: "ordered" }, { list: "bullet" }],
                    [{ script: "sub" }, { script: "super" }],
                    [{ indent: "-1" }, { indent: "+1" }],
                    [{ direction: "rtl" }],
                    [{ size: ["small", false, "large", "huge"] }],
                    [{ header: [1, 2, 3, 4, 5, 6, false] }],
                    [{ color: [] }, { background: [] }],
                    [{ font: [] }],
                    [{ align: [] }],
                    ["clean"],
                  ],
                }}
                formats={[
                  "header",
                  "font",
                  "size",
                  "bold",
                  "italic",
                  "underline",
                  "strike",
                  "blockquote",
                  "code-block",
                  "list",
                  "bullet",
                  "indent",
                  "link",
                  "image",
                  "video",
                  "color",
                  "background",
                  "align",
                  "script",
                  { name: "preserve-spaces", type: "inline" },
                ]}
                style={{
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  whiteSpace: "pre-wrap",
                }}
              />
            </div>
          </div></CardContent></Card>
          <div style={{ marginBottom: "20px" }}>
  <label
    style={{
      fontWeight: "bold",
      display: "block",
      marginBottom: "8px",
    }}
  >
    Step 3: Add Tags (Mandatory)
  </label>
  <TextField
    fullWidth
    size="small"
    placeholder="Tags (comma-separated, e.g., Programming, IMAGES)"
    value={tagsInput}
    onChange={(e) => {
      const input = e.target.value;
      setTagsInput(input);

      const formattedTags = input
        .split(",")
        .map((tag) => tag.trim())
        .filter((tag) => tag !== "")
        .map((tag) => ({ name: tag }));

      setTags(formattedTags);
    }}
  />
</div>
      <div
        onClick={() => {
          if (!permissions.can_create_tf && !permissions.is_admin) {
            showSnackbar("You don't have permission to create True/False Questions.", "warning");
            return;
          }
          handleApiCall();
        }}
        style={{ display: "inline-block", cursor: (permissions.can_create_tf || permissions.is_admin) ? "pointer" : "not-allowed", 
          marginBottom: "24px", // Add spacing after the button 
          }}
      >
        <Button
          variant="contained"
          disabled={
  !(permissions.can_create_tf || permissions.is_admin) ||
  isLoadingPermissions ||
  !isFormValid
}
          size="small"
          sx={{
            background: "linear-gradient(135deg, #1e3a8a 0%, #1e8bafff 100%)",
            color: "white",
            padding: "6px 16px",     // reduced size
            fontSize: "0.85rem",     // smaller text
            fontWeight: "700",
            borderRadius: "8px",     // slightly smaller radius
            textTransform: "none",
            boxShadow: "0 8px 25px rgba(30, 58, 138, 0.4)",
            transition: "all 0.3s ease",
            "&:hover": {
              background: "linear-gradient(135deg, #1e8bafff 0%, #1e3a8a 100%)",
              transform: "translateY(-3px)",
              boxShadow: "0 12px 35px rgba(30, 58, 138, 0.5)",
            },
           "&.Mui-disabled": {
  background: "#e5e7eb",
  color: "#9ca3af",
  opacity: 1,
  boxShadow: "none",
  cursor: "not-allowed",
},
          }}
          startIcon={<AddIcon></AddIcon>}
        >
          ADD FLASHCARD
        </Button>
      </div>


      {permissions.can_read_tf || permissions.is_admin ? (
        <div>
          <ul className="card-list" style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {cards.map((card, index) => (
              <li
                key={index}
                style={{
                  marginTop: "24px",
                  marginBottom: "16px",
                  borderRadius: "16px",
                  transition: "all 0.3s ease",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
                  backgroundColor: mode === "dark" ? "#2A2A3E" : "#fff",
                  border: "1px solid",
                  borderColor: mode === "dark" ? "#333" : "#e0e7ff",
                  position: "relative",
                  padding: "16px",
                  ":hover": {
                    boxShadow: "0 8px 30px rgba(102, 126, 234, 0.2)",
                    transform: "translateY(-4px)",
                  },
                }}
              >
                <div style={{ padding: 0 }}>
                  {/* Question Section */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                      paddingRight: "40px",
                      maxWidth: "calc(100% - 70px)",
                      whiteSpace: "pre-wrap",
                      marginBottom: "16px",
                    }}
                  >
                    <div
                      style={{
                        background: "linear-gradient(135deg, #1e3a8a 0%, #1e8bafff 100%)",
                        color: "white",
                        padding: "8px 14px",
                        borderRadius: "10px",
                        fontWeight: "800",
                        fontSize: "1.1rem",
                        marginRight: "16px",
                        minWidth: "45px",
                        textAlign: "center",
                        boxShadow: "0 4px 15px rgba(30, 58, 138, 0.3)",
                      }}
                    >
                      Q.{index + 1}
                    </div>
                    <span style={{ flex: 1, display: "flex", alignItems: "center" }}>
                      <strong>{renderContent(card.question)}</strong>
                    </span>
                  </div>

                  {/* Icons Section */}
                  <div
                    style={{
                      position: "absolute",
                      top: "20px",
                      right: "20px",
                      display: "flex",
                      gap: "14px",
                      zIndex: 10,
                      padding: "10px 14px",
                      borderRadius: "12px",
                      backdropFilter: "blur(10px)",
                    }}
                  >
                    {/* Expand/Collapse Icon */}
                    <i
                      className={`bi ${card.expanded ? "bi-arrows-angle-contract" : "bi-arrows-angle-expand"}`}
                      title={card.expanded ? "Contract" : "Expand"}
                      onClick={() => toggleCardExpand(index)}
                      style={{
                        cursor: "pointer",
                        fontSize: "1.2rem",
                        color: "#667eea",
                        transition: "all 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = "#764ba2";
                        e.currentTarget.style.transform = "scale(1.2)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = "#667eea";
                        e.currentTarget.style.transform = "scale(1)";
                      }}
                    ></i>
                    {/* View Flashcard Icon */}
  <Tooltip title="View Flashcard">
    <i
      className="bi bi-eye"
      onClick={() => openViewModal(card)}
      style={{
        cursor: "pointer",
        fontSize: "1.2rem",
        color: "#0ea5e9",
        transition: "all 0.2s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.color = "#0284c7";
        e.currentTarget.style.transform = "scale(1.2)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.color = "#0ea5e9";
        e.currentTarget.style.transform = "scale(1)";
      }}
    ></i>
  </Tooltip>
                    {/* Edit Icon */}
                    <i
                      className="bi bi-pencil-square"
                      title="Edit"
                      onClick={() => openEditModal(index)}
                      style={{
                        cursor: permissions.can_update_tf || permissions.is_admin ? "pointer" : "not-allowed",
                        opacity: permissions.can_update_tf || permissions.is_admin ? 1 : 0.4,
                        fontSize: "1.2rem",
                        color: "#10b981",
                        transition: "all 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        if (permissions.can_update_tf || permissions.is_admin) {
                          e.currentTarget.style.color = "#059669";
                          e.currentTarget.style.transform = "scale(1.2)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = "#10b981";
                        e.currentTarget.style.transform = "scale(1)";
                      }}
                    ></i>

                    {/* Delete Icon */}
                    <i
                      className="bi bi-trash3"
                      title="Delete"
                      onClick={() => openDeleteDialog(index)}
                      style={{
                        cursor: permissions.can_delete_tf || permissions.is_admin ? "pointer" : "not-allowed",
                        opacity: permissions.can_delete_tf || permissions.is_admin ? 1 : 0.4,
                        fontSize: "1.2rem",
                        color: "#ef4444",
                        transition: "all 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        if (permissions.can_delete_tf || permissions.is_admin) {
                          e.currentTarget.style.color = "#dc2626";
                          e.currentTarget.style.transform = "scale(1.2)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = "#ef4444";
                        e.currentTarget.style.transform = "scale(1)";
                      }}
                    ></i>

                    {/* Tag Icon */}
                    <i
                      className="bi bi-tags"
                      title="Tag"
                      onClick={(e) => openTagModal(index, e)}
                      style={{
                        cursor: "pointer",
                        opacity: 1,
                        fontSize: "1.2rem",
                        color: "#8b5cf6",
                        transition: "all 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = "#7c3aed";
                        e.currentTarget.style.transform = "scale(1.2)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = "#8b5cf6";
                        e.currentTarget.style.transform = "scale(1)";
                      }}
                    ></i>
                  </div>

                  {/* Expanded Content */}
                  {card.expanded && (permissions.can_read_tf || permissions.is_admin) && (
                    <>
                      {/* Answer Section */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          wordBreak: "break-word",
                          overflowWrap: "break-word",
                          whiteSpace: "pre-wrap",
                          marginBottom: "16px",
                        }}
                      >
                        <div
                          style={{
                            background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                            color: "white",
                            padding: "8px 14px",
                            borderRadius: "10px",
                            fontWeight: "800",
                            fontSize: "1.1rem",
                            marginRight: "16px",
                            minWidth: "45px",
                            textAlign: "center",
                            boxShadow: "0 4px 15px rgba(16, 185, 129, 0.3)",
                          }}
                        >
                          A
                        </div>
                        <span style={{ flex: 1, display: "flex", alignItems: "center" }}>
                          {typeof card.answer === "boolean" ? card.answer ? "True" : "False" : card.answer}
                        </span>
                      </div>

                      {/* Explanation Section */}
                      {card.explanation && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            wordBreak: "break-word",
                            overflowWrap: "break-word",
                            whiteSpace: "pre-wrap",
                            marginBottom: "16px",
                          }}
                        >
                          <div
                            style={{
                              background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                              color: "white",
                              padding: "6px 12px",
                              borderRadius: "8px",
                              fontWeight: "700",
                              fontSize: "0.9rem",
                              marginRight: "14px",
                              minWidth: "fit-content",
                              whiteSpace: "nowrap",
                            }}
                          >
                            💡 Explanation
                          </div>
                          <span style={{ flex: 1, display: "flex", alignItems: "center" }}>
                            {renderContent(card.explanation)}
                          </span>
                        </div>
                      )}

                      {/* Tags Section */}
                      <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "8px" }}>
                        {card.tags.map((tag, idx) => (
                          <span
                            key={tag.id}
                            style={{
                              backgroundColor: mode === "dark" ? "#333" : "#f0f0f0",
                              color: mode === "dark" ? "#fff" : "#333",
                              padding: "4px 8px",
                              borderRadius: "12px",
                              fontSize: "0.8rem",
                              border: "1px solid",
                              borderColor: mode === "dark" ? "#555" : "#ddd",
                            }}
                          >
                            #{tag.name}
                          </span>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          You don't have permission to view True/False Questions.
        </div>
      )}

      {/* Edit Modal */}
    <Dialog
  open={editModalOpen}
  onClose={handleCloseModal}
  maxWidth="md"
  fullWidth
  PaperProps={{
    sx: {
      borderRadius: '16px',
      background: mode === 'dark' ? '#1E1E2E' : mode === 'custom' ? customColors.cardBg : '#ffffff',
      boxShadow: mode === 'dark'
        ? '0 8px 32px rgba(0, 0, 0, 0.4)'
        : '0 8px 32px rgba(0, 0, 0, 0.1)',
      overflow: 'hidden',
    }
  }}
>
  {/* Gradient Header */}
  <Box sx={{
    background: mode === 'dark'
      ? 'linear-gradient(135deg, #1e3a8a 0%, #1e8bafff 100%)'
      : mode === 'custom'
        ? customColors.gradient
        : 'linear-gradient(135deg, #1e3a8a 0%, #1e8bafff 100%)',
    p: 3,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: 'white',
  }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Box sx={{
        width: 48,
        height: 48,
        borderRadius: '12px',
        background: 'rgba(255, 255, 255, 0.2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <i className="bi bi-pencil-square" style={{ fontSize: 28 }}></i>
      </Box>
      <Box>
        <Typography variant="h5" sx={{ fontWeight: '700', mb: 0.5 }}>
          Edit Flashcard
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.9 }}>
          Update your flashcard details below
        </Typography>
      </Box>
    </Box>
  </Box>

  {/* Content with improved styling */}
  <DialogContent sx={{
    p: 4,
    background: mode === 'dark' ? '#1E1E2E' : mode === 'custom' ? customColors.background : '#ffffff',
  }}>
    {/* Question Field */}
    <Box sx={{ mb: 3 }}>
      <Typography
        variant="subtitle1"
        sx={{
          mb: 1.5,
          fontWeight: 600,
          color: mode === 'dark' ? '#fff' : mode === 'custom' ? customColors.text : '#000',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Box sx={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #1e3a8a 0%, #1e8bafff 100%)',
        }} />
        Question <span style={{ color: '#ef4444' }}>*</span>
      </Typography>
      <Box className={`editor-wrapper ${mode}-mode`} sx={{ position: 'relative' }}>
        <ReactQuill
          value={editQuestion}
          onChange={setEditQuestion}
          placeholder="Enter your question here"
          theme="snow"
          modules={{
            toolbar: [
              ["bold", "italic", "underline", "strike"],
              ["blockquote", "code-block"],
              [{ header: 1 }, { header: 2 }],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ script: "sub" }, { script: "super" }],
              [{ indent: "-1" }, { indent: "+1" }],
              [{ direction: "rtl" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ["clean"],
            ],
          }}
          formats={[
            "header", "font", "size", "bold", "italic", "underline", "strike",
            "blockquote", "code-block", "list", "bullet", "indent", "link",
            "image", "video", "color", "background", "align", "script",
          ]}
        />
      </Box>
    </Box>

    {/* Answer Field */}
    <Box sx={{ mb: 3 }}>
      <Typography
        variant="subtitle1"
        sx={{
          mb: 1.5,
          fontWeight: 600,
          color: mode === 'dark' ? '#fff' : mode === 'custom' ? customColors.text : '#000',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Box sx={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        }} />
        Answer <span style={{ color: '#ef4444' }}>*</span>
      </Typography>
      <FormControl variant="outlined" fullWidth>
        <InputLabel id="edit-answer-label">Answer</InputLabel>
        <Select
          labelId="edit-answer-label"
          value={editAnswer}
          onChange={(e) => setEditAnswer(e.target.value)}
          label="Answer"
          sx={{
            background: mode === 'dark' ? '#2A2A3E' : mode === 'custom' ? customColors.background : '#fff',
          }}
        >
          <MenuItem value="True">True</MenuItem>
          <MenuItem value="False">False</MenuItem>
        </Select>
      </FormControl>
    </Box>

    {/* Explanation Field */}
    <Box>
      <Typography
        variant="subtitle1"
        sx={{
          mb: 1.5,
          fontWeight: 600,
          color: mode === 'dark' ? '#fff' : mode === 'custom' ? customColors.text : '#000',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Box sx={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
        }} />
        Explanation
      </Typography>
      <Box className={`editor-wrapper ${mode}-mode`} sx={{ position: 'relative' }}>
        <ReactQuill
          value={editExplanation}
          onChange={setEditExplanation}
          placeholder="Enter your explanation here"
          theme="snow"
          modules={{
            toolbar: [
              ["bold", "italic", "underline", "strike"],
              ["blockquote", "code-block"],
              [{ header: 1 }, { header: 2 }],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ script: "sub" }, { script: "super" }],
              [{ indent: "-1" }, { indent: "+1" }],
              [{ direction: "rtl" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ["clean"],
            ],
          }}
          formats={[
            "header", "font", "size", "bold", "italic", "underline", "strike",
            "blockquote", "code-block", "list", "bullet", "indent", "link",
            "image", "video", "color", "background", "align", "script",
          ]}
        />
      </Box>
    </Box>
  </DialogContent>
<TextField
  fullWidth
  size="small"
  placeholder="Tags (comma-separated, e.g., Programming, IMAGES)"
  value={tagsInput}
  onChange={(e) => {
    const input = e.target.value;
    setTagsInput(input);

    const formattedTags = input
      .split(",")
      .map((tag) => tag.trim())
      .filter((tag) => tag !== "")
      .map((tag) => ({ name: tag }));

    setTags(formattedTags);
  }}
/>
  {/* Enhanced Actions */}
  <DialogActions sx={{
    p: 3,
    gap: 2,
    background: mode === 'dark' ? '#2A2A3E' : mode === 'custom' ? customColors.background : '#f8f9fa',
  }}>
    <Button
      onClick={handleCloseModal}
      variant="outlined"
      sx={{
        borderColor: mode === 'dark' ? '#555' : mode === 'custom' ? customColors.border : '#d1d5db',
        color: mode === 'dark' ? '#A0A0A6' : mode === 'custom' ? customColors.textSecondary : '#6B7280',
        '&:hover': {
          borderColor: mode === 'dark' ? '#fff' : mode === 'custom' ? customColors.text : '#000',
          background: 'transparent',
        }
      }}
    >
      Cancel
    </Button>
    <Button
      onClick={handleUpdateCard}
      variant="contained"
      disabled={!(permissions.can_update_tf || permissions.is_admin)}
      sx={{
        background: 'linear-gradient(135deg, #1e3a8a 0%, #1e8bafff 100%)',
        color: 'white',
        fontWeight: 600,
        px: 4,
        '&:hover': {
          background: 'linear-gradient(135deg, #1e8bafff 0%, #1e3a8a 100%)',
          transform: 'translateY(-2px)',
          boxShadow: '0 8px 20px rgba(30, 58, 138, 0.3)',
        },
        '&.Mui-disabled': {
          background: '#d1d5db',
          color: 'white',
          opacity: 0.6,
        },
        transition: 'all 0.3s ease',
      }}
    >
      Save Changes
    </Button>
  </DialogActions>
</Dialog>


      {/* Delete Dialog */}
      <Dialog
  open={deleteDialogOpen}
  onClose={handleCloseDeleteDialog}
  maxWidth="sm"
  fullWidth
  PaperProps={{
    sx: {
      borderRadius: '20px',
      background: mode === 'dark' ? '#1E1E2E' : mode === 'custom' ? customColors.cardBg : '#ffffff',
      boxShadow: mode === 'dark'
        ? '0 8px 32px rgba(0, 0, 0, 0.4)'
        : '0 8px 32px rgba(239, 68, 68, 0.2)',
      overflow: 'hidden',
    }
  }}
>
  {/* Warning Header */}
  <Box sx={{
    background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
    p: 3,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: 'white',
  }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Box sx={{
        width: 48,
        height: 48,
        borderRadius: '12px',
        background: 'rgba(255, 255, 255, 0.2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        {/* <i className="bi bi-exclamation-triangle" style={{ fontSize: 28 }}></i> */}
           <i className="bi bi-trash3" style={{
          fontSize: 40,
          // color: '#ef4444',
        }}></i>
      </Box>
      <Box>
        <Typography variant="h5" sx={{ fontWeight: '700', mb: 0.5 }}>
          Delete Flashcard
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.9 }}>
          This action cannot be undone
        </Typography>
      </Box>
    </Box>
  </Box>

  {/* Content */}
  <DialogContent sx={{
    p: 4,
    background: mode === 'dark' ? '#1E1E2E' : mode === 'custom' ? customColors.background : '#ffffff',
  }}>
    <Box sx={{
      textAlign: 'center',
      py: 2,
    }}>
      {/* <Box sx={{
        width: 80,
        height: 80,
        borderRadius: '50%',
        background: mode === 'dark'
          ? 'rgba(239, 68, 68, 0.1)'
          : 'rgba(239, 68, 68, 0.05)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 24px',
      }}>
      
      </Box> */}
      <Typography
        variant="h6"
        sx={{
          mb: 2,
          color: mode === 'dark' ? '#fff' : mode === 'custom' ? customColors.text : '#000',
          fontWeight: 600,
        }}
      >
        Are you sure you want to delete this flashcard?
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: mode === 'dark' ? '#A0A0A6' : mode === 'custom' ? customColors.textSecondary : '#6B7280',
          lineHeight: 1.6,
        }}
      >
        This will permanently remove the flashcard and all associated data. This action cannot be reversed.
      </Typography>
    </Box>
  </DialogContent>

  {/* Actions */}
  <DialogActions sx={{
    p: 3,
    gap: 2,
    background: mode === 'dark' ? '#2A2A3E' : mode === 'custom' ? customColors.background : '#f8f9fa',
  }}>
    <Button
      onClick={handleCloseDeleteDialog}
      variant="outlined"
      fullWidth
      sx={{
        borderColor: mode === 'dark' ? '#555' : mode === 'custom' ? customColors.border : '#d1d5db',
        color: mode === 'dark' ? '#fff' : mode === 'custom' ? customColors.text : '#000',
        fontWeight: 600,
        '&:hover': {
          borderColor: mode === 'dark' ? '#fff' : mode === 'custom' ? customColors.text : '#000',
          background: 'transparent',
        }
      }}
    >
      Cancel
    </Button>
    <Button
      onClick={handleDeleteCard}
      variant="contained"
      fullWidth
      disabled={!(permissions.can_delete_tf || permissions.is_admin)}
      sx={{
        background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
        color: 'white',
        fontWeight: 600,
        '&:hover': {
          background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
          transform: 'translateY(-2px)',
          boxShadow: '0 8px 20px rgba(239, 68, 68, 0.4)',
        },
        '&.Mui-disabled': {
          background: '#d1d5db',
          color: 'white',
          opacity: 0.6,
        },
        transition: 'all 0.3s ease',
      }}
    >
      Delete Flashcard
    </Button>
  </DialogActions>
</Dialog>


      {/* Tag Modal */}
      <TagModal
        open={tagModalOpen}
        position={tagModalPosition}
        onClose={() => setTagModalOpen(false)}
        subfolderId={subfolder_id}
        cardId={cards[tagCardIndex]?.id}
        cardQuestionType={cards[tagCardIndex]?.question_type}
        onTagAdded={handleTagAdded}
        onTagUpdated={handleTagUpdated}
        onTagDeleted={handleTagDeleted}
        onShowSnackbar={showSnackbar}
      />

      {/* Popover for Editing Selected Text */}
      <Popover
        open={popoverOpen}
        anchorEl={popoverAnchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <div style={{ padding: "16px", width: "300px" }}>
          <ReactQuill
            value={popoverContent}
            onChange={handlePopoverChange}
            theme="snow"
            style={{ height: "100px", marginBottom: "8px" }}
          />
          <div
            style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}
          >
            <Button
              onClick={handlePopoverClose}
              color="secondary"
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              onClick={handlePopoverSave}
              color="primary"
              variant="contained"
            >
              Save
            </Button>
          </div>
        </div>
      </Popover>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: "100%" }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
      {/* duplicate confirmation dialog */}
      <Dialog open={duplicateDialogOpen} onClose={handleCancelDuplicate}>
        <DialogTitle sx={{ background: mode === 'dark' ? 'linear-gradient(to right, #142be1, #44a6e9)' : mode === 'custom' ? customColors.background : 'linear-gradient(to right, #142be1, #44a6e9)' }}>Duplicate Question</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ color: mode === 'dark' ? '#ffffff' : mode === 'custom' ? customColors.text : '#000000' }}>
            A flashcard with this question already exists. Do you want to add it anyway?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDuplicate} sx={{
            backgroundColor: mode === 'dark' ? '#142be1' : mode === 'custom' ? customColors.primary : '#44a6e9',
            '&:hover': { backgroundColor: mode === 'dark' ? '#0d1abf' : mode === 'custom' ? customColors.background : '#0d1abf' }
          }}>Cancel</Button>
          <Button
            onClick={handleConfirmDuplicate}
            sx={{
              backgroundColor: mode === 'dark' ? '#142be1' : mode === 'custom' ? customColors.primary : '#44a6e9',
              '&:hover': { backgroundColor: mode === 'dark' ? '#0d1abf' : mode === 'custom' ? customColors.background : '#0d1abf' }
            }}
            disabled={!permissions.can_create_tf || permissions.is_admin}
            variant="contained"
            color="primary"
          >
            Add Anyway
          </Button>
        </DialogActions>
      </Dialog>

   <Dialog
  open={userGuideOpen}
  onClose={() => setUserGuideOpen(false)}
  maxWidth="md"
  fullWidth
  PaperProps={{
    sx: {
      borderRadius: "16px",
      boxShadow: mode === "dark"
        ? "0 8px 32px rgba(0, 0, 0, 0.4)"
        : "0 8px 32px rgba(30, 139, 175, 0.15)",
      overflow: "hidden",
      background: mode === "dark"
        ? "#1E1B18"
        : mode === "custom"
          ? customColors.bg
          : "#ffffff",
    },
  }}
>
  {/* Header */}
  <Box
    sx={{
      background: "linear-gradient(135deg, #1e3a8a 0%, #1e8bafff 100%)",
      p: 3,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      color: "white",
    }}
  >
    <Box>
      <Typography variant="h5" sx={{ fontWeight: "700", mb: 0.5 }}>
        User Guide
      </Typography>
      <Typography variant="body2" sx={{ opacity: 0.9 }}>
        True/False Questions
      </Typography>
    </Box>
    <IconButton
      onClick={() => setUserGuideOpen(false)}
      sx={{
        color: "white",
        "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.1)" },
      }}
    >
      <CloseIcon />
    </IconButton>
  </Box>

  {/* Content */}
  <DialogContent
    sx={{
      p: 4,
      overflowY: "auto",
      maxHeight: "75vh",
      "&::-webkit-scrollbar": {
        width: "10px",
      },
      "&::-webkit-scrollbar-track": {
        background: mode === "dark"
          ? "#2d3748"
          : mode === "custom"
            ? customColors.scrollTrack
            : "#f1f5f9",
        borderRadius: "6px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: mode === "dark"
          ? "#475569"
          : mode === "custom"
            ? customColors.scrollThumb
            : "#94a3b8",
        borderRadius: "6px",
        border: `2px solid ${
          mode === "dark"
            ? "#2d3748"
            : mode === "custom"
              ? customColors.border
              : "#f1f5f9"
        }`,
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: mode === "dark"
          ? "#64748b"
          : mode === "custom"
            ? customColors.scrollThumbHover
            : "#475569",
      },
      scrollbarWidth: "thin",
      scrollbarColor: mode === "dark"
        ? "#475569 #2d3748"
        : mode === "custom"
          ? `${customColors.scrollThumb} ${customColors.scrollTrack}`
          : "#94a3b8 #f1f5f9",
      background: mode === "dark"
        ? "#1E1B18"
        : mode === "custom"
          ? customColors.bg
          : "#ffffff",
      color: mode === "dark"
        ? "rgba(255, 255, 255, 0.87)"
        : mode === "custom"
          ? customColors.text
          : "rgba(30, 27, 24, 0.87)",
    }}
  >
    {/* Question Section */}
    <Box sx={{ mb: 4 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "10px",
            background: "linear-gradient(135deg, #1e3a8a 0%, #1e8bafff 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mr: 2,
          }}
        >
          <i className="bi bi-card-text" style={{ color: "white", fontSize: 20 }}></i>
        </Box>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "600",
            color: mode === "dark"
              ? "#e0e0e0"
              : mode === "custom"
                ? customColors.text
                : "#1E1B18",
          }}
        >
          Question
        </Typography>
      </Box>
      <Typography
        variant="body2"
        sx={{
          color: mode === "dark"
            ? "rgba(255, 255, 255, 0.7)"
            : mode === "custom"
              ? customColors.textSecondary
              : "rgba(30, 27, 24, 0.7)",
          lineHeight: 1.7,
          pl: 7,
        }}
      >
        Enter your question in the <strong>Question</strong> field. You can use rich text formatting, including bold, italics, and LaTeX for mathematical expressions.
      </Typography>
    </Box>

    {/* Answer Section */}
    <Box sx={{ mb: 4 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "10px",
            background: "linear-gradient(135deg, #1e3a8a 0%, #1e8bafff 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mr: 2,
          }}
        >
          <i className="bi bi-chat-text" style={{ color: "white", fontSize: 20 }}></i>
        </Box>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "600",
            color: mode === "dark"
              ? "#e0e0e0"
              : mode === "custom"
                ? customColors.text
                : "#1E1B18",
          }}
        >
          Answer
        </Typography>
      </Box>
      <Typography
        variant="body2"
        sx={{
          color: mode === "dark"
            ? "rgba(255, 255, 255, 0.7)"
            : mode === "custom"
              ? customColors.textSecondary
              : "rgba(30, 27, 24, 0.7)",
          lineHeight: 1.7,
          pl: 7,
        }}
      >
        Select the correct answer from the dropdown: <strong>True</strong> or <strong>False</strong>.
      </Typography>
    </Box>

    {/* Explanation Section */}
    <Box sx={{ mb: 4 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "10px",
            background: "linear-gradient(135deg, #1e3a8a 0%, #1e8bafff 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mr: 2,
          }}
        >
          <i className="bi bi-lightbulb" style={{ color: "white", fontSize: 20 }}></i>
        </Box>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "600",
            color: mode === "dark"
              ? "#e0e0e0"
              : mode === "custom"
                ? customColors.text
                : "#1E1B18",
          }}
        >
          Explanation
        </Typography>
      </Box>
      <Typography
        variant="body2"
        sx={{
          color: mode === "dark"
            ? "rgba(255, 255, 255, 0.7)"
            : mode === "custom"
              ? customColors.textSecondary
              : "rgba(30, 27, 24, 0.7)",
          lineHeight: 1.7,
          pl: 7,
        }}
      >
        Optionally, add an explanation in the <strong>Explanation</strong> field. This can provide additional context or details about the answer.
      </Typography>
    </Box>

    {/* Add Flashcard Section */}
    <Box sx={{ mb: 4 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "10px",
            background: "linear-gradient(135deg, #1e3a8a 0%, #1e8bafff 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mr: 2,
          }}
        >
          <AddIcon sx={{ color: "white", fontSize: 20 }} />
        </Box>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "600",
            color: mode === "dark"
              ? "#e0e0e0"
              : mode === "custom"
                ? customColors.text
                : "#1E1B18",
          }}
        >
          Add Flashcard
        </Typography>
      </Box>
      <Typography
        variant="body2"
        sx={{
          color: mode === "dark"
            ? "rgba(255, 255, 255, 0.7)"
            : mode === "custom"
              ? customColors.textSecondary
              : "rgba(30, 27, 24, 0.7)",
          lineHeight: 1.7,
          pl: 7,
        }}
      >
        Click the <strong>Add Flashcard</strong> button to save your question, answer, and explanation. If the question already exists, you'll be prompted to confirm.
      </Typography>
    </Box>

    {/* Flashcard List Section */}
    <Box sx={{ mb: 4 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "10px",
            background: "linear-gradient(135deg, #1e3a8a 0%, #1e8bafff 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mr: 2,
          }}
        >
          <i className="bi bi-card-list" style={{ color: "white", fontSize: 20 }}></i>
        </Box>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "600",
            color: mode === "dark"
              ? "#e0e0e0"
              : mode === "custom"
                ? customColors.text
                : "#1E1B18",
          }}
        >
          Flashcard List
        </Typography>
      </Box>
      <Typography
        variant="body2"
        sx={{
          color: mode === "dark"
            ? "rgba(255, 255, 255, 0.7)"
            : mode === "custom"
              ? customColors.textSecondary
              : "rgba(30, 27, 24, 0.7)",
          lineHeight: 1.7,
          pl: 7,
        }}
      >
        View your list of flashcards below. You can <strong>expand</strong>, <strong>edit</strong>, <strong>delete</strong>, or <strong>tag</strong> each flashcard.
      </Typography>
    </Box>

    {/* Pro Tips */}
    <Box
      sx={{
        p: 3,
        borderRadius: "12px",
        bgcolor: mode === "dark"
          ? "rgba(144, 202, 249, 0.05)"
          : mode === "custom"
            ? customColors.bgSecondary
            : "rgba(30, 139, 175, 0.05)",
        border: mode === "dark"
          ? "1px solid rgba(144, 202, 249, 0.2)"
          : mode === "custom"
            ? `1px solid ${customColors.border}`
            : "1px solid rgba(30, 139, 175, 0.2)",
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          fontWeight: "600",
          color: mode === "dark"
            ? "#90caf9"
            : mode === "custom"
              ? customColors.text
              : "#1e8bafff",
          mb: 2,
        }}
      >
        💡 Quick Tips
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Typography
          variant="body2"
          sx={{
            color: mode === "dark"
              ? "rgba(255, 255, 255, 0.7)"
              : mode === "custom"
                ? customColors.textSecondary
                : "rgba(30, 27, 24, 0.7)",
            lineHeight: 1.7,
          }}
        >
          • Use the toolbar to format your question and explanation.
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: mode === "dark"
              ? "rgba(255, 255, 255, 0.7)"
              : mode === "custom"
                ? customColors.textSecondary
                : "rgba(30, 27, 24, 0.7)",
            lineHeight: 1.7,
          }}
        >
          • Use LaTeX for mathematical expressions by enclosing them in `$...$` or `$$...$$`.
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: mode === "dark"
              ? "rgba(255, 255, 255, 0.7)"
              : mode === "custom"
                ? customColors.textSecondary
                : "rgba(30, 27, 24, 0.7)",
            lineHeight: 1.7,
          }}
        >
          • Click the <strong>Expand/Collapse</strong> icon to show or hide flashcard details.
        </Typography>
      </Box>
    </Box>
  </DialogContent>
</Dialog>


    </div>
        ) : (
          // Read-only mode UI (similar to FillInTheBlanks)
          <div>
            {/* Header */}
            <Typography
              variant="h4"
              sx={{
                mb: 3,
                fontWeight: "800",
                background: mode === "dark" ? "linear-gradient(135deg, #f0f7ff 0%, #e0e7ff 100%)" : "linear-gradient(135deg, #1e3a8a 0%, #1e8bafff 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              True/False Questions
            </Typography>

            {/* Read-only flashcard list */}
            <ul className="card-list" style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {cards.length > 0 ? (
                cards.map((card, index) => (
                  <li
                    key={index}
                    style={{
                      position: "relative",
                      padding: "16px",
                      borderRadius: "16px",
                      marginBottom: "16px",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                      maxWidth: "100%",
                      whiteSpace: "pre-wrap",
                      border: mode === "dark" ? "1px solid #333" : "1px solid #e0e7ff",
                      backgroundColor: mode === "dark" ? "#2A2A3E" : "#fff",
                      boxShadow: mode === "dark" ? "0 4px 14px rgba(0,0,0,0.6)" : "0 4px 12px rgba(15,23,42,0.08)",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-4px)";
                      e.currentTarget.style.boxShadow = mode === "dark" ? "0 8px 30px rgba(0,0,0,0.75)" : "0 8px 30px rgba(102, 126, 234, 0.2)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = mode === "dark" ? "0 4px 14px rgba(0,0,0,0.6)" : "0 4px 12px rgba(15,23,42,0.08)";
                    }}
                  >
                    {/* Question */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        paddingRight: "40px",
                        maxWidth: "calc(100% - 70px)",
                        whiteSpace: "pre-wrap",
                        marginBottom: "16px",
                      }}
                    >
                      <div
                        style={{
                          background: "linear-gradient(135deg, #1e3a8a 0%, #1e8bafff 100%)",
                          color: "white",
                          padding: "8px 14px",
                          borderRadius: "10px",
                          fontWeight: "800",
                          fontSize: "1.1rem",
                          marginRight: "16px",
                          minWidth: "45px",
                          textAlign: "center",
                          boxShadow: "0 4px 15px rgba(30, 58, 138, 0.3)",
                        }}
                      >
                        Q
                      </div>
                      <span style={{ flex: 1, display: "flex", alignItems: "center" }}>
                        <strong>{renderContent(card.question)}</strong>
                      </span>
                    </div>

                    {/* Expand/Collapse Icon ONLY */}
                    <div
                      style={{
                        position: "absolute",
                        top: "20px",
                        right: "20px",
                        display: "flex",
                        gap: "14px",
                        zIndex: 10,
                        padding: "10px 14px",
                        borderRadius: "12px",
                        backdropFilter: "blur(10px)",
                      }}
                    >
                      <i
                        className={`bi ${card.expanded ? "bi-arrows-angle-contract" : "bi-arrows-angle-expand"}`}
                        title={card.expanded ? "Contract" : "Expand"}
                        onClick={() => toggleCardExpand(index)}
                        style={{
                          cursor: "pointer",
                          fontSize: "1.2rem",
                          color: "#667eea",
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.color = "#764ba2";
                          e.currentTarget.style.transform = "scale(1.2)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.color = "#667eea";
                          e.currentTarget.style.transform = "scale(1)";
                        }}
                      ></i>
                    </div>

                    {/* Expanded content - Answer and Explanation ONLY */}
                    {card.expanded && (
                      <>
                        {/* Answer Section */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            wordBreak: "break-word",
                            overflowWrap: "break-word",
                            whiteSpace: "pre-wrap",
                            marginBottom: "16px",
                          }}
                        >
                          <div
                            style={{
                              background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                              color: "white",
                              padding: "8px 14px",
                              borderRadius: "10px",
                              fontWeight: "800",
                              fontSize: "1.1rem",
                              marginRight: "16px",
                              minWidth: "45px",
                              textAlign: "center",
                              boxShadow: "0 4px 15px rgba(16, 185, 129, 0.3)",
                            }}
                          >
                            A
                          </div>
                          <span style={{ flex: 1, display: "flex", alignItems: "center" }}>
                            {typeof card.answer === "boolean" ? card.answer ? "True" : "False" : card.answer}
                          </span>
                        </div>

                        {/* Explanation Section */}
                        {card.explanation && (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              wordBreak: "break-word",
                              overflowWrap: "break-word",
                              whiteSpace: "pre-wrap",
                              marginBottom: "16px",
                            }}
                          >
                            <div
                              style={{
                                background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                                color: "white",
                                padding: "6px 12px",
                                borderRadius: "8px",
                                fontWeight: "700",
                                fontSize: "0.9rem",
                                marginRight: "14px",
                                minWidth: "fit-content",
                                whiteSpace: "nowrap",
                              }}
                            >
                              💡 Explanation
                            </div>
                            <span style={{ flex: 1 }}>{renderContent(card.explanation)}</span>
                          </div>
                        )}
                      </>
                    )}
                  </li>
                ))
              ) : (
                <li style={{ padding: "16px" }}>
                  <Typography>No Questions Available</Typography>
                </li>
              )}
            </ul>
          </div>
        )}
      </>
    )}
    {/* View Flashcard Dialog */}
<Dialog
  open={viewModalOpen}
  onClose={() => setViewModalOpen(false)}
  maxWidth="md"
  fullWidth
  PaperProps={{
    sx: {
      borderRadius: 18,
      overflow: "hidden",
      boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
      background: "linear-gradient(135deg, #1e3a8a 0%, #1e8bafff 100%)",
    }
  }}
>
  <Box
    sx={{
      minHeight: 520,
      display: "flex",
      flexDirection: "column",
      p: { xs: 2, sm: 4 },
    }}
  >
    {/* Header */}
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 3,
        px: 2,
      }}
    >
      <Box
        sx={{
          backgroundColor: "rgba(255,255,255,0.2)",
          color: "#fff",
          padding: "8px 24px",
          borderRadius: 20,
          fontWeight: "bold",
          fontSize: "0.95rem",
          backdropFilter: "blur(10px)",
        }}
      >
        Question 1 of 1
      </Box>

      <IconButton
        onClick={() => setViewModalOpen(false)}
        sx={{
          color: "#fff",
          "&:hover": { backgroundColor: "rgba(255,255,255,0.18)" },
        }}
      >
        <CloseIcon fontSize="large" />
      </IconButton>
    </Box>

    {/* Scrollable white content */}
    <Box
      sx={{
        backgroundColor: "#ffffff",
        borderRadius: 16,
        p: { xs: 3, sm: 5 },
        flex: 1,
        display: "flex",
        flexDirection: "column",
        boxShadow: "inset 0 2px 12px rgba(0,0,0,0.08)",
        color: "#000000",
        overflowY: "auto",
        maxHeight: "75vh",
        "&::-webkit-scrollbar": { width: "8px" },
        "&::-webkit-scrollbar-track": { background: "#f1f1f1", borderRadius: "10px" },
        "&::-webkit-scrollbar-thumb": { background: "#888", borderRadius: "10px" },
        "&::-webkit-scrollbar-thumb:hover": { background: "#555" },
      }}
    >
      {/* Question */}
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          mb: 5,
          lineHeight: 1.5,
          textAlign: "center",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
        }}
      >
        {viewedCard && renderContent(viewedCard.question)}
      </Typography>

      {/* Options - True/False buttons */}
<Box sx={{ display: "flex", justifyContent: "center", gap: 5, mb: 6 }}>
  <Button
    disableRipple
    sx={{
      width: 300,                     
      height: 55,                     
      backgroundColor: "#ffffff",
      border: "1px solid #9e9e9e",    
      borderRadius: 8,
      color: "#424242",               
      fontSize: "1.4rem",
      fontWeight: 500,
      textTransform: "none",
      boxShadow: "0 3px 10px rgba(0,0,0,0.08)",
      "&:hover": {
        backgroundColor: "#f5f5f5",
        borderColor: "#757575",
      },
    }}
  >
    True
  </Button>

  <Button
    disableRipple
    sx={{
      width: 300,
      height: 55,
      backgroundColor: "#ffffff",
      border: "1px solid #9e9e9e",
      borderRadius: 8,
      color: "#424242",
      fontSize: "1.4rem",
      fontWeight: 500,
      textTransform: "none",
      boxShadow: "0 3px 10px rgba(0,0,0,0.08)",
      "&:hover": {
        backgroundColor: "#f5f5f5",
        borderColor: "#757575",
      },
    }}
  >
    False
  </Button>
</Box>
      {/* Show Answer / Revealed + Feedback */}
      {!showAnswer ? (
        <Box sx={{ mt: "auto", display: "flex", justifyContent: "center" }}>
          <Button
            onClick={() => setShowAnswer(true)}
            sx={{
              background: "linear-gradient(135deg, #1e3a8a 0%, #1e8bafff 100%)",
              color: "#fff",
              padding: "10px 28px",
              borderRadius: 30,
              fontSize: "0.95rem",
              fontWeight: "bold",
              textTransform: "none",
              boxShadow: "0 5px 14px rgba(102,126,234,0.3)",
              "&:hover": {
                background: "linear-gradient(135deg, #1e8bafff 0%, #1e3a8a 100%)",
                transform: "translateY(-2px)",
              },
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <span style={{ fontSize: "1.2rem" }}>👁️</span>
            Show Answer
          </Button>
        </Box>
      ) : (
        <Box sx={{ mt: 4, pt: 3, borderTop: "2px solid #e0e0e0" }}>
          {/* Correct Answer */}
<Box
  sx={{
    background: "#e3f2fd",
    borderRadius: 16,
    p: 4,
    mb: 5,
    border: "1px solid #90caf9",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    textAlign: "center",
  }}
>
  <Typography
    variant="h6"
    sx={{
      color: "#0288d1",
      fontWeight: 700,
      mb: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: 1.5,
      fontSize: "1.35rem",
    }}
  >
    ✓ Answer:
  </Typography>

  <Typography
    variant="h5"
    sx={{
      color: "#01579b",
      fontWeight: 600,
      fontSize: "1.8rem",
      mb: 2,
    }}
  >
    {viewedCard?.answer ? "True" : "False"}
  </Typography>

  {/* Explanation / hint line */}
  {viewedCard?.explanation && (
    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
      <span style={{ fontSize: "1.8rem", color: "#ffb300" }}>💡</span>
      <Typography
        variant="body1"
        sx={{
          color: "#424242",
          lineHeight: 1.4,
        }}
      >
        {renderContent(viewedCard.explanation)}
      </Typography>
    </Box>
  )}
</Box>

          {/* Feedback Icons */}
          <Typography variant="subtitle2" align="center" sx={{ mb: 2, color: "#666", fontWeight: 600 }}>
            How well did you know this?
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "space-around", flexWrap: "wrap", gap: 1 }}>
            <ImageButton onClick={() => {}}>
              <Image src={skip} alt="skip" />
              <Typography variant="caption" sx={{ fontWeight: 500 }}>Skip</Typography>
            </ImageButton>
            <ImageButton onClick={() => {}}>
              <Image src={forgot} alt="forgot" />
              <Typography variant="caption" sx={{ fontWeight: 500 }}>Forgot</Typography>
            </ImageButton>
            <ImageButton onClick={() => {}}>
              <Image src={partially} alt="partially" />
              <Typography variant="caption" sx={{ fontWeight: 500 }}>Partial</Typography>
            </ImageButton>
            <ImageButton onClick={() => {}}>
              <Image src={efforts} alt="efforts" />
              <Typography variant="caption" sx={{ fontWeight: 500 }}>With Effort</Typography>
            </ImageButton>
            <ImageButton onClick={() => {}}>
              <Image src={convenient} alt="convenient" />
              <Typography variant="caption" sx={{ fontWeight: 500 }}>Easy</Typography>
            </ImageButton>
          </Box>
        </Box>
      )}
    </Box>
  </Box>
</Dialog>
  </div>
);



};

export default TrueFalse;
